module.exports = __webpack_public_path__ + "img/b1@2x.e5f29c7e.png";